import { AfterViewInit, Component, inject, input, output, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UiButtonComponent, UIIconComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../../components/bottom-sheet/bottom-sheet.component';
import { DepositPaymentResult } from './deposit-payment-result.model';

/**
 * The sheet the bank's callback lands on. The callback result is presented as a simple
 * success/error state; operational payment events are not user-facing content here.
 */
@Component({
	selector: 'app-deposit-payment-result',
	imports: [BottomSheetComponent, UiButtonComponent, UIIconComponent],
	templateUrl: './deposit-payment-result.component.html',
	host: { 'data-cy': 'deposit-payment-result' }
})
export class DepositPaymentResultComponent implements AfterViewInit {
	private readonly router = inject(Router);
	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	readonly result = input.required<DepositPaymentResult>();

	/** The sheet went down, and the payment it reported may have moved the history along. */
	readonly dismissed = output<void>();

	ngAfterViewInit(): void {
		this.sheet()?.open();
	}

	onClose(): void {
		this.sheet()?.close();
	}

	/**
	 * However the sheet goes down — «بستن», the backdrop, a swipe or the back button — the
	 * trader leaves the deposit form for the wallet; the callback URL is replaced so back
	 * does not land on the result again.
	 */
	onClosed(): void {
		this.router.navigate(['/wallet'], { replaceUrl: true });
	}
}
